export default __webpack_public_path__ + "static/media/wf.90bbae0d.svg";